import { createI18n } from 'vue-i18n';
import { DefaultLocale, fetchLocaleMessages } from './locales';

export default async function createI18nInstance(locale: string) {
  const localeMessagesFromAPI = await fetchLocaleMessages();
  return createI18n({
    legacy: false,
    locale: locale ?? DefaultLocale,
    fallbackLocale: DefaultLocale,
    messages: localeMessagesFromAPI,
    silentTranslationWarn: true, // Suppress warnings when translation not found
    warnHtmlMessage: false, // Suppress warnings when message is not string
    globalInjection: true,
    // ideally we wouldn't disable these warnings but as we have no translation solution currently it generates
    // a lot of warning spam that is not fixable, consider re-enabling once translation solution in place
    fallbackWarn: false,
    missingWarn: false,
  });
}
